// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2roQS","content":"styles_content__2DwRB"};